import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
const initialState = {
    soulSelf: null,
};
export const useSoulSelfStore = create()(devtools((set, get) => ({
    ...initialState,
    // Soul全体の管理
    setSoulSelf: (soulSelf) => set({ soulSelf }),
    updateSoulSelf: (updates) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, ...updates } : null
    })),
    resetSoulSelf: () => set({ soulSelf: null }),
    // 各プロパティの個別更新
    setId: (id) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, id } : null
    })),
    setDisplayName: (displayName) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, displayName } : null
    })),
    setIsAnonymous: (isAnonymous) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, isAnonymous } : null
    })),
    setDepth: (depth) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, depth } : null
    })),
    setPain: (pain) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, pain: Math.max(0, pain) } : null
    })),
    setSuffering: (suffering) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, suffering: Math.max(0, suffering) } : null
    })),
    setIsDead: (isDead) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, isDead, } : null
    })),
    setDeathTime: (deathTime) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, deathTime } : null
    })),
    setDeathCount: (deathCount) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, deathCount } : null
    })),
    setDepthUpdatedAt: (depthUpdatedAt) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, depthUpdatedAt } : null
    })),
    setPainUpdatedAt: (painUpdatedAt) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, painUpdatedAt } : null
    })),
    setSufferingUpdatedAt: (sufferingUpdatedAt) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, sufferingUpdatedAt } : null
    })),
    setLastActivity: (lastActivity) => set((state) => ({
        soulSelf: state.soulSelf ? { ...state.soulSelf, lastActivity } : null
    })),
}), {
    name: 'soul-self-store',
}));
